// uiFlags.ts — reversible UI experiments. Flip a flag back to false to fully
// revert that change with no other edits.

// NEW_UI — the structural redesign cutover switch (see REDESIGN.md).
//
// CUTOVER (live): the redesign is now the DEFAULT. NEW_UI is ON unless explicitly
// switched off, so every production build (web + native) ships the new app.
//
// KILL-SWITCH / instant rollback: set VITE_NEW_UI=false for the build to fully
// revert to the previous design — the entire old app still lives behind `!NEW_UI`,
// so nothing else needs changing. On the web: add `VITE_NEW_UI=false` in Cloudflare
// Pages → Production env vars and redeploy. In native: rebuild with VITE_NEW_UI=false.
export const NEW_UI = import.meta.env.VITE_NEW_UI !== 'false';

// Varied, content-aware feed tiles: reading / reflection / aha lessons render as
// a shorter horizontal tile (image left ~30%, text right). Reflections sit on
// soft lined paper; aha tiles add a gold glow. Video keeps its poster. Upcoming
// items show the same full tile, faded and inactive.
// Set to false to restore the original poster-hero + compact-strip feed tiles.
export const VARIANT_TILES = true;

// Testimonials persist beneath the current tile until tapped away — they no
// longer vanish when the lesson above is completed. (Tied to VARIANT_TILES so a
// single flag reverts the whole feed change.)
export const PERSIST_TESTIMONIALS = true;

// "Aha moment" reflections — a special gold-highlighted reflection variant plus
// an "Aha moments" filter in Your Stuff. Removed per clinical review (they add no
// value: review note act3-c06-l09). With this off, every such step is just a
// normal reflection and no aha surfaces render. Flip to true to restore.
export const AHA_MOMENTS = false;
